module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.25b5fe1.woff2";